<template>
  <div class="wizard sw-main sw-theme-default">
    <ul class="nav nav-tabs step-anchor">
      <li :style="{ width: 100/steps.length + '%' }" :class="{'active': currentStep >= index, 'active tab': modeWizard === 'tab'}" v-for="(step, index) of steps">
        <a :href="`#step${index+1}`" @click="goPage(index)">
          <span class="number" v-if="modeWizard !== 'tab'">{{ index+1 }}</span>
          <span class="info text-ellipsis">{{step.label}}
            <small>{{step.description}}</small>
          </span>
        </a>
      </li>
    </ul>
    <div class="sw-container tab-content">
      <slot :name="currentSlot"></slot>
    </div>
    <nav class="navbar btn-toolbar sw-toolbar sw-toolbar-bottom">
      <!--div class="btn-group navbar-btn sw-btn-group pull-right" role="group">
        <button class="btn btn-default sw-btn-prev disabled" type="button">Previous</button>
        <button class="btn btn-default sw-btn-next" type="button">Next</button>
      </div -->
      <div class="btn-group pull-right" role="group" v-if="modeWizard !== 'tab'">
        <a href="#previous" :class="{ 'disabled': !backEnabled }" class="pull-right btn btn-primary get-started rounded-pill" style="border-radius: 20px;" tabindex="-1" @click="goBack()">❮ Previous</a>
        <a href="#next" v-if="!isFinalStep" class="pull-right btn btn-primary get-started rounded-pill" style="border-radius: 20px;" @click="goNext()">Save & Next ❯</a>
        <a href="#submit" v-if="isFinalStep" class="btn btn-primary get-started rounded-pill" style="border-radius: 20px;"@click="doSubmit()"><i class="fa fa-check-circle pe-2" aria-hidden="true"></i>Submit Catalog</a>
      </div>
      <div class="btn-group  pull-right" v-if="modeWizard === 'tab'">
        <a href="#next" v-if="isFinalStep" class="btn btn-primary get-started rounded-pill"style="border-radius: 20px;" @click="doSave()">Save</a>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'wizard',
  props: {
    steps: {},
    onNext: {},
    onBack: {},
    onSave: {},
    onSubmit: {},
    modeWizard: {}
  },
  data() {
    return {
      currentStep: 0
    }
  },
  computed: {
    currentSlot() {
      return this.steps[this.currentStep].slot
    },
    backEnabled() {
      return this.currentStep !== 0
    },
    isFinalStep() {
      return this.currentStep === (this.steps.length - 1)
    }
  },
  methods: {
    goNext(skipFunction) {
      if (!skipFunction && typeof this.onNext === 'function') {
        if (!this.onNext(this.currentStep)) {
          return
        }
      }
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++
      }
    },
    goBack(skipFunction) {
      if (!skipFunction && typeof this.onBack === 'function') {
        if (!this.onBack(this.currentStep)) {
          return
        }
      }
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    goPage(pageIndex) {
      if (this.modeWizard !== 'tab') return
      if (pageIndex !== this.currentStep) {
        this.currentStep = pageIndex
      }
    },
    doSave(skipFunction) {
      if (!skipFunction && typeof this.onSave === 'function') {
        if (!this.onSave(this.currentStep)) {
          return false
        }
        return true
      }
    },
    doSubmit(skipFunction) {
      if (!skipFunction && typeof this.onSubmit === 'function') {
        if (!this.onSubmit(this.currentStep)) {
          return false
        }
        return true
      }
    }
  }
}
</script>
<style>
.sw-main .sw-toolbar .btn{
  border-radius: 20px !important;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Wizard.vue